const forums = [
  `开幕式+主论坛`,
  `医疗AI及大模型应用发展论坛`,
  `智慧医院创新发展论坛`,
  `药械国际市场拓展论坛`,
  `药企数字化营销论坛`,
  `磐霖资本创新生物医药及医疗器械研发专场研讨论坛`,
  `脑机接口产业创新与投资论坛`,
  `血管介入创新与投资论坛`,
  `创新药价值实现“最后一公里”攻坚论坛`,
  `眼科创新与投资论坛`,
  `影像设备与核心零部件应用与投资论坛`,
  `呼吸睡眠健康创新与投资论坛`,
  `AI赋能医学成果转化沙龙`,
  `慢病管理与健康险创新论坛`,
  `肿瘤诊疗一体化创新与投资论坛`,
  `港股创新药市场与机遇论坛`,
  `优质资产推介会`,
  `医学人文主题演讲论坛`,
  `院外市场新渠道新商业增长大会`,
]
const needList = [
  '项目或产品需要宣传推广，如设展、路演等',
  '公司/项目找投资及BD伙伴',
  '寻找有融资和BD需求的创新公司及优秀项目',
  '了解行业政策趋势, 参加会议论坛，学习交流',
  '关注新产品新技术，为业务规划和采购做准备',
  '寻找出海资源及合作伙伴',
  '与现有的合作方会面',
  '寻找供应商（CXO企业、原辅包设企业、仪器企业、第三方服务机构等），采购产品/服务',
  '寻找代理商/销售商需求',
  '其他需求，请填写',
]
const serviceList = [
  '我是投资人，希望找有融资需求的创新企业',
  '我是有融资需求的创新企业，希望找投资人/投资机构',
  '我是项目持有方，希望找BD进行项目合作',
  '我有其他对接需求（寻找CXO、供应商、销售商等），请填写',
  '我不需要项目对接服务',
]
export { needList, forums, serviceList }